import LenderSubmitApplications from './LenderSubmitApplications';

export default LenderSubmitApplications;
